import React from 'react';
import { Link } from 'react-router-dom';
import { useOverdueStatus } from './hooks/useOverdueStatus';
import { useAuth0 } from '@auth0/auth0-react';
import { hasPermission, PERMISSIONS } from '../../../_metronic/helpers/UserRoleHelpers';

const OverdueAlert: React.FC = () => {
  const { hasOverdue, loading } = useOverdueStatus();
  const { user } = useAuth0();

  // Não mostrar nada se estiver carregando ou não houver débitos
  if (loading || !hasOverdue) {
    return null;
  }

  // Verificar se o usuário tem permissão para ver a tela de cobranças
  const currentCustomer = window.localStorage.getItem("activeCustomer") || "";
  const canViewBilling = user && currentCustomer && hasPermission(user, currentCustomer, PERMISSIONS.MANAGE_SETTINGS);

  return (
    <div className="row g-6 g-xl-9 mb-10">
      <div className="col-md-12">
        <div className="alert alert-danger d-flex align-items-center border border-danger">
          <i className="bi bi-exclamation-triangle-fill fs-2x text-danger me-4"></i>
          <div className="d-flex flex-column flex-grow-1">
            <h4 className="mb-1 text-danger">
              ⚠️ Atenção: Você possui débitos em aberto!
            </h4>
            <div className="fw-semibold text-gray-700">
              Regularize sua situação para evitar interrupção dos serviços.
            </div>
          </div>
          {canViewBilling && (
            <Link to="/billing/invoices" className="btn btn-danger btn-lg ms-3">
              <i className="bi bi-credit-card me-2"></i>
              Ver Cobranças
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default OverdueAlert;

